"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPOSTHeaders = addPOSTHeaders;
exports.default = genericFetch;
exports.getGenericErrorObject = getGenericErrorObject;
exports.rawGenericFetch = void 0;
exports.validateStatus = validateStatus;
var _axios = _interopRequireDefault(require("axios"));
var _ApiConst = require("./ApiConst");
/* eslint-disable no-mixed-operators */

_axios.default.defaults.timeout = 35000;

/**
 * Checks if a network request came back fine, and throws an error if not
 */
function validateStatus(status) {
  if (status >= 200 && status < 300) {
    return true;
  }
  return false;
  // throw { errorCode: status, errorMessage:
}

// To DO
// Uncomment this code when security headers going to enable from backend

function addPOSTHeaders(options = {}) {
  return {
    ...options,
    headers: {
      ...options.headers,
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'SAMEORIGIN',
      'X-Content-Type-Options': 'nosniff',
      'Content-Security-Policy': 'script-src "self"',
      'Permissions-Policy': 'payment=()"',
      'Referrer-Policy': 'strict-origin',
      'X-XSS-Protection': '1; mode=block',
      'Content-Type': options.headers && options.headers['Content-Type'] || 'application/json; charset=UTF-8'
    }
  };
}
function parseBody(options = {}) {
  return options.body ? {
    ...options,
    body: JSON.stringify(options.body)
  } : options;
}
function parseResponse(responseParam) {
  let response = responseParam.data;
  response = {
    ...response,
    status: responseParam.status || ''
  };
  return response;
}
function getGenericErrorObject({
  error,
  options
}) {
  var _options$headers, _error$response4;
  let errorCode = '';
  let errorMessage = '';
  const apiErrorMessage = JSON.stringify(error);
  const traceId = options === null || options === void 0 || (_options$headers = options.headers) === null || _options$headers === void 0 ? void 0 : _options$headers.traceId;
  if (_ApiConst.isThereMobile) {
    var _error$response;
    if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
      var _error$response2;
      errorCode = 61398;
      errorMessage = 'Access Token Expire';
      const objError = {
        errorCode,
        errorMessage,
        data: (error === null || error === void 0 || (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) || (error === null || error === void 0 ? void 0 : error.errorResponse),
        traceId,
        apiErrorMessage,
        reqURL: options === null || options === void 0 ? void 0 : options.url
      };
      return objError;
    }
  }
  if (error !== null && error !== void 0 && error.response) {
    var _error$response3;
    // Request made and server responded
    if (error !== null && error !== void 0 && error.response && error !== null && error !== void 0 && (_error$response3 = error.response) !== null && _error$response3 !== void 0 && _error$response3.data) {
      const {
        code,
        msg,
        data,
        message
      } = error.response.data;
      const {
        status
      } = error.response;
      if (code) {
        errorCode = status || 'as_new_api_error';
        errorMessage = msg || message || 'Error Message';
      } else if (data) {
        errorCode = status || 'as_api_error';
        errorMessage = data.message || 'Error Message';
      } else {
        const axiosErrors = JSON.parse(JSON.stringify(error));
        errorCode = status || axiosErrors.message || 'unknown_api_axios_error';
        errorMessage = 'Error Message';
      }
    } else {
      errorCode = 'unknown_api_error';
      errorMessage = 'Error Message';
    }
  } else if (error !== null && error !== void 0 && error.request) {
    // The request was made but no response was received
    const axiosErrors = JSON.parse(JSON.stringify(error));
    if (axiosErrors && axiosErrors.code && axiosErrors.code === 'ECONNABORTED') {
      errorCode = 'timeout';
      errorMessage = 'Connection Timeout';
    } else if (axiosErrors && axiosErrors.message && axiosErrors.message === 'Network Error') {
      errorCode = 'NETWORK_ERROR';
      errorMessage = 'No Network connection';
    } else {
      errorCode = axiosErrors.code || 'axios_error';
      errorMessage = axiosErrors.message || 'Error Message';
    }
  } else {
    var _error$errorResponse, _error$errorResponse2;
    // Something happened in setting up the request that triggered an Error
    errorCode = (error === null || error === void 0 ? void 0 : error.errorCode) || (error === null || error === void 0 ? void 0 : error.code) || error && (error === null || error === void 0 ? void 0 : error.errorResponse) && (error === null || error === void 0 || (_error$errorResponse = error.errorResponse) === null || _error$errorResponse === void 0 ? void 0 : _error$errorResponse.data) && (error === null || error === void 0 || (_error$errorResponse2 = error.errorResponse) === null || _error$errorResponse2 === void 0 || (_error$errorResponse2 = _error$errorResponse2.data) === null || _error$errorResponse2 === void 0 ? void 0 : _error$errorResponse2.code) || 'axios_error_unknown_code';
    errorMessage = (error === null || error === void 0 ? void 0 : error.errorMessage) || (error === null || error === void 0 ? void 0 : error.message) || 'Error Message';
  }
  if (errorMessage && errorMessage === 'Access Token Expire') {
    errorCode = 61398;
    errorMessage = 'Access Token Expire';
  }
  const objError = {
    errorCode,
    errorMessage,
    data: (error === null || error === void 0 || (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data) || (error === null || error === void 0 ? void 0 : error.errorResponse),
    traceId,
    apiErrorMessage,
    reqURL: options === null || options === void 0 ? void 0 : options.url
  };
  return objError;
}
const rawGenericFetch = options => (0, _axios.default)(options).then(response => parseResponse(response)).catch(err => {
  throw getGenericErrorObject(err, options);
});
/**
 * Requests a URL, returning a promise
 *
 * @param {string} url The URL we want to request
 * @param {object} [options] The options we want to pass to "fetch"
 *
 * @return {object} The response data
 */
exports.rawGenericFetch = rawGenericFetch;
function genericFetch({
  url,
  options,
  formData,
  addHeaders = true
}) {
  const optionsWithHeaders = addHeaders ? addPOSTHeaders(options) : {};
  let parsedOptions;
  if (formData) {
    parsedOptions = optionsWithHeaders;
    parsedOptions.timeout = 600000;
  } else {
    parsedOptions = parseBody(optionsWithHeaders);
  }
  parsedOptions.url = url;
  parsedOptions.data = parsedOptions.body;
  if (formData) {
    delete parsedOptions.body;
  }
  parsedOptions.validateStatus = validateStatus;
  parsedOptions.onUploadProgress = options.onUploadProgress;
  return rawGenericFetch(parsedOptions);
}